<template>
  <div class="logsummary">
  
       <section class="toolbar">
         <div class="toolbar-container">
            <router-link id="back-button" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
            <h1>Logs</h1>
         </div>
      </section>
      <div class="clearfix"></div>
      <div class="clearfix"></div>
      <section class="start-container">
         <div class="start-status vvg-fullwidth">
            <div class="pull-left">Today</div>
            <div class="pull-right">{{ total_time }}</div>
         </div>
      </section>
      <section class="list-view">
         <div class="list-view-title">
            <h2>Summary</h2>
         </div>
         <div class="list-container">
            <div class = "accordian-container">
               <div class="panel-group" id="accordion">
                        <div v-for="(val,key) in items" v-bind:key="key" class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" :href="'#'+key">
                                    <ul>
                                        <li>
                                            <div class="list-view-left">{{ key  }}</div>
                                            <!--<div class="list-view-right">
                                            <img src="/static/images/clock.png">
                                            8 hr 0 min
                                            </div>-->
                                        </li>
                                    </ul>
                                </a>
                                </h4>
                            </div>
                            <div :id="key" class="panel-collapse collapse">
                                <div class="panel-body">
                                <div class="accordion-internal-container">
                                        <div v-for="(obj,index) in val" v-bind:key="index" class="accordion-internal-container-block">
                                            <div class="pull-left">{{ obj.key }}</div>
                                            <div class="pull-right">{{ obj.value }}</div>
                                        </div>
                                </div>
                                </div>
                            </div>
                        </div>
               </div>
            </div>
            <!-- end container -->
         </div>
      </section>
      <section class="submit-section">
         <button type="submit" v-on:click = "signLog()" class="btn btn-default">Sign Log</button>
      </section>
  </div>
</template>

<script>

export default {
  name: "logsummary",
  data: () => ({
    total_time : "",
    items : {}
  }),
  mounted: function() {
    this.call();
  },
  methods: {
    signLog : function() {
      var self = this;
      self.$router.push("/operator/sign-log");
    },

    call : function () {
      var self = this;
      $.ajax({
        url:
          self.$config.API+"/v1/operator/log-summary",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function(res) {

          if ( res.status == "success" ) {

            var data = res.data.logData

            self.total_time = data.total_time;
            self.items = data.items;
          }
          
        },
        error: function(jqXHR, exception) {
          //if session expired
          if ( jqXHR.responseJSON.code == 401 ) {
            self.$router.push(
              "/v1/operator/login"
            )  
          } else if ( jqXHR.responseJSON.code == 400 ) {
            alert(jqXHR.responseJSON.messge);
          }
            
        }
      });
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/logsummary.vue